export default function apiUrl() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    return "https://brandonshepherd.cpteller.com/api/onetaxapi.cfc";
  } else {
    console.log("IS PRODUCTION ENVIRONMENT");
    

    //check that there is a subdomain to cpteller.com if not redirect to secure.cpteller.com
    if(window.location.hostname.split('.').length === 1 ) {
      window.location = `https://secure.cpteller.com${window.location.pathname}`;
    }
   

    return `https://${window.location.hostname}/api/onetaxapi.cfc`;
  }
}
